import BookingSummaryCard from "./BookingSummaryCard";
import SwipeableViews from "react-swipeable-views";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedBooking } from "../../../../../redux/slice/booking/bookingSlice";
import { BookingSummary as BookingSummaryProps } from "../../../../../types/bookingCreation";
import { RootState } from "../../../../../redux/store";

interface Props {
  userReservation: BookingSummaryProps[];
  serviceType: string;
}

function BookingSummary(props: Props) {
  const dispatch = useDispatch();
  const selectedBooking = useSelector((state: RootState) => state.booking.selectedBooking);
  const summaryBookings = useSelector((state: RootState) => state.booking.bookingSummary);
  const rentalExpired = useSelector((state: RootState) => state.booking.rentalExpired);
  const gracePeriodMinutes = useSelector(
      (state: RootState) => state.tenantConfig.config.gracePeriodMinutes
  );

  const initialActiveStep = selectedBooking
    ? summaryBookings?.findIndex((booking: any) => booking.id === selectedBooking.id)
    : 0;
  const [activeStep, setActiveStep] = useState(initialActiveStep !== -1 ? initialActiveStep : 0);
  useEffect(() => {
    if (props.userReservation.length > 0) {
      const payload = props.userReservation[0]
          ? { ...props.userReservation[0], gracePeriodMinutes: gracePeriodMinutes}
          : null
      dispatch(setSelectedBooking(payload));
    }
  }, [props.userReservation, dispatch]);

  useEffect(() => {
    setActiveStep(0);
  }, [props.serviceType]);

  const handleChangeIndex = (index: number) => {
    setActiveStep(index);
    updateFocusedItem(index);
  };

  const updateFocusedItem = (index: number) => {
    if (props.userReservation.length > index && index >= 0) {
      const payload = props.userReservation[index]
          ? { ...props.userReservation[index], gracePeriodMinutes: gracePeriodMinutes}
          : null
      dispatch(setSelectedBooking(payload));
    }
  };

  return (
    <div className="flex flex-row overflow-hidden relative">
      <SwipeableViews
        axis="x"
        index={activeStep}
        onChangeIndex={handleChangeIndex}
        enableMouseEvents // Enable swiping with a mouse
        className="px-5 w-[380px] overflow-visible no-scrollbar my-5"
        style={{
          padding: "0 40px",
        }}
      >
        {props.userReservation?.map((bookingItem, index) => (
          <div
            key={bookingItem.id}
            className={`w-[280px] ${
              index === activeStep ? "blur-none opacity-100" : "blur-[1px] opacity-98"
            }`}
          >
            <BookingSummaryCard
              serviceType={props.serviceType}
              bookingSummaryData={bookingItem}
              rentalExpired={rentalExpired}
              amount={1}
            />
          </div>
        ))}
      </SwipeableViews>
    </div>
  );
}

export default BookingSummary;
